<template>
	<div class="benefits" id="benefits">
		<div class="topFixed">
			<div class="top">
				<h1 class="logo" @click="back">
					红匣子游戏
				</h1>
				<ul class="nav">
					<li @click="back"><p>返回首页</p><span></span></li>
					<!-- <li class="on" ><p>关于我们</p><span></span></li>
					<li class="" ><p>公司理念</p><span></span></li> -->
					<li class="on" ><p>公司福利</p><span></span></li>
					<li class="" ><router-link :to="{path:'/recruit'}"><p>加入我们</p></router-link><span></span></li>
				</ul>
				<!-- <div class="lang-nav" @click="langNavShow = !langNavShow">
					<ul v-if="langNavShow">
						<li class="on"><a href="www.baidu.com">简体中文</a></li>
						<li><a href="www.baidu.com">繁體中文</a></li>
						<li><a href="www.baidu.com">English</a></li>
						<li><a href="www.baidu.com">日本語</a></li>
						<li><a href="www.baidu.com">한국어</a></li>
					</ul>
				</div> -->
			</div>
		</div>
		<div class="mian">
			<div class="m m_1" id="m_1">
				<img src="https://d.cubeverse.games/imgs/recruit/banner.jpg" width="100%"/>
			</div>
			<div class="m m_2" id="m_2">
				<div class="m_2_title">
					<h1>{{ langConfig.benefits.m_2  }}</h1>
					<p>{{ langConfig.benefits.m_2_title  }} <br> {{ langConfig.benefits.m_2_title2 }} </p>
				</div>
				<div class="m_2_c m_2_1">
					<img class="m_2_c_pic" src="https://d.cubeverse.games/imgs/benefits/pic_1.jpg" width="100%">
					<div class="m_2_c_p m_2_p">
						<h3>{{ langConfig.benefits.m_2_1  }}</h3>
						<i></i>
						<p>{{ langConfig.benefits.m_2_1_p  }} <br> {{ langConfig.benefits.m_2_1_p2  }}</p>
					</div>
				</div>
				<div class="m_2_c m_2_2">
					<div class="m_2_c_p m_2_p">
						<h3>{{ langConfig.benefits.m_2_2 }}</h3>
						<i></i>
						<p>{{ langConfig.benefits.m_2_2_p  }} <br> {{ langConfig.benefits.m_2_2_p2  }}</p>
					</div>
					<img class="m_2_c_pic" src="https://d.cubeverse.games/imgs/benefits/pic_2.jpg" width="100%">
				</div>
				<div class="m_2_c m_2_2">
					<img class="m_2_c_pic" src="https://d.cubeverse.games/imgs/benefits/pic_3.jpg" width="100%">
					<div class="m_2_c_p m_2_p">
						<h3>{{ langConfig.benefits.m_2_3  }}</h3>
						<i></i>
						<p>{{ langConfig.benefits.m_2_3_p  }} <br> {{ langConfig.benefits.m_2_3_p2  }}</p>
					</div>
				</div>
				<div class="m_2_c m_2_2">
					<div class="m_2_c_p m_2_p">
						<h3>{{ langConfig.benefits.m_2_4  }}</h3>
						<i></i>
						<p>{{ langConfig.benefits.m_2_4_p  }} <br> {{ langConfig.benefits.m_2_4_p2  }} <br> {{ langConfig.benefits.m_2_4_p3 }}</p>
					</div>
					<img class="m_2_c_pic" src="https://d.cubeverse.games/imgs/benefits/pic_4.jpg" width="100%">
				</div>
				<div class="m_2_c m_2_2">
					<img class="m_2_c_pic" src="https://d.cubeverse.games/imgs/benefits/pic_5.jpg" width="100%">
					<div class="m_2_c_p m_2_p">
						<h3>{{ langConfig.benefits.m_2_5  }}</h3>
						<i></i>
						<p>{{ langConfig.benefits.m_2_5_p  }} <br> {{ langConfig.benefits.m_2_5_p2  }}</p>
					</div>
				</div>
				<div class="m_2_c m_2_2">
					<div class="m_2_c_p m_2_p">
						<h3>{{ langConfig.benefits.m_2_6  }}</h3>
						<i></i>
						<p>{{ langConfig.benefits.m_2_6_p  }}</p>
					</div>
					<img class="m_2_c_pic" src="https://d.cubeverse.games/imgs/benefits/pic_6.jpg" width="100%">
				</div>
				<div class="m_2_c m_2_2">
					<img class="m_2_c_pic" src="https://d.cubeverse.games/imgs/benefits/pic_7.jpg" width="100%">
					<div class="m_2_c_p m_2_p">
						<h3>{{ langConfig.benefits.m_2_7  }}</h3>
						<i></i>
						<p>{{ langConfig.benefits.m_2_7_p  }} <br> {{ langConfig.benefits.m_2_7_p2  }}</p>
					</div>
				</div>
			</div>
			<Footer class="m m_8 footer" id="m_8"/>
		</div>
	</div>
</template>

<script>
import Vue from "vue";
import "@/assets/styles/benefits.css";
import Footer from "@/components/pc/Footer.vue";
import langzhcn from './config/zh-cn.json';
import langzhhk from './config/zh-cht.json';
import langenus from './config/en-us.json';
import langjajp from './config/ja-jp.json';
import langkokr from './config/ko-kr.json';
import Cookies from 'js-cookie';
import zhCN from "vue-easytable/libs/locale/lang/zh-CN";

// import enUS from "vue-easytable/libs/locale/lang/en-US";
// this.$veLocale.use(enUS);

// 防刷
import debounce from "lodash/debounce";

// Simulation table data from database

export default {
    name: "recruit",
    components: {
			Footer
    },
    data () {
			return {
				loadingInstance: null,
				langNavShow: false,
				lang: Cookies.get('lang') ? Cookies.get('lang') : 'zh-cn',
				langConfig: langzhcn
			};
    },
		computed: {
		},
    mounted () {
			this.handleLoading();
    },
    methods: {
			/**
			 * @function handleLoading 处理加载
			 */
			handleLoading(){
				console.log("初始化");
				let Dlang = process.env.VUE_APP_VERSION;
				console.log('Dlang: ' + process.env.VUE_APP_VERSION);
				switch(Dlang) {
					case "zh": 
						this.lang = "zh-cn";
						this.langConfig = langzhcn;
					break;
					case "zh-cht": 
						this.lang = "zh-cht";
						this.langConfig = langzhhk;
					break;
					case "en": 
						this.lang = "en-us";
						this.langConfig = langenus;
					break;
					case "ja": 
						this.lang = "ja-jp";
						this.langConfig = langjajp;
					break;
					case "ko": 
						this.lang = "ko-kr";
						this.langConfig = langkokr;
					break;
					default:
				}
			},
			/**
			 * @function back 回到主页
			 */
			back() {
				// this.$router.push({path: "/"})
				let url1 = window.location.host;
				console.log('url1', url1)
				console.log('url1', "http://"+url1+"/zh")
				window.location.href= "http://"+url1+"/zh"
			}
		}
};
</script>
